module.exports = __webpack_public_path__ + "static/img/Q20.3a50cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Q20.png
// module id = 7DMP
// module chunks = 2